import React from "react";
import { config, dom } from "@fortawesome/fontawesome-svg-core";

const IconLibrary = () => {
  config.autoAddCss = false;
  return <style>{dom.css()}</style>;
};

export default IconLibrary;
